import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation = { __typename?: 'RootMutationType', revokeMemberInvitation?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const RevokeMemberInvitationOnWorkspaceSettingsMembersPageDocument = gql`
    mutation revokeMemberInvitationOnWorkspaceSettingsMembersPage($id: ID!) {
  revokeMemberInvitation(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationFn = Apollo.MutationFunction<RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation, RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>;

/**
 * __useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation__
 *
 * To run a mutation, you first call `useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMemberInvitationOnWorkspaceSettingsMembersPageMutation, { data, loading, error }] = useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation(baseOptions?: Apollo.MutationHookOptions<RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation, RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation, RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>(RevokeMemberInvitationOnWorkspaceSettingsMembersPageDocument, options);
      }
export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationHookResult = ReturnType<typeof useRevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation>;
export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationResult = Apollo.MutationResult<RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation>;
export type RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationOptions = Apollo.BaseMutationOptions<RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutation, RevokeMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>;